export default {
    issue_date: 'Datum izdavanja',
    name: 'Naziv fakture',
    download: 'Preuzimanja',
    download_button: 'Preuzmite',
    price: 'Cijena',
    paid: 'Plaćeno',
    rest_to_pay: 'Preostalo za plaćanje:',
    paid_in_advance: 'U pretplati:',
    all_paid: 'Sve obaveze izmirene',
}
